import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import PhoneInput from "react-phone-input-2"
import "react-phone-input-2/lib/style.css"

import styles from "./PhoneNumberInput.module.scss"

const PhoneNumberInput = ({
  id,
  value,
  onChange,
  inputStyle = "",
  buttonStyle = "",
  errorStyle = "",
  errorButtonStyle = "",
  displayError = false,
  fullHeight = false
}) => {
  const inputClasses = classNames(inputStyle || styles.input, {
    [errorStyle || styles.error]: displayError
  })

  const buttonClasses = classNames(buttonStyle || styles.button, {
    [errorButtonStyle || styles.error]: displayError
  })

  return (
    <PhoneInput
      id={id}
      value={value || ""}
      country="us"
      placeholder="Enter phone number"
      preferredCountries={["us", "ca"]}
      onChange={(phoneValue) => onChange(phoneValue)}
      inputClass={inputClasses}
      buttonClass={buttonClasses}
      dropdownClass={styles.countryList}
      containerClass={classNames(styles.container, {
        [styles.fullHeight]: fullHeight
      })}
      enableSearch
      searchPlaceholder="Search Country"
      countryCodeEditable={false}
    />
  )
}

PhoneNumberInput.propTypes = {
  id: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  validated: PropTypes.bool,
  inputStyle: PropTypes.string,
  buttonStyle: PropTypes.string,
  errorStyle: PropTypes.string,
  errorButtonStyle: PropTypes.string,
  displayError: PropTypes.bool,
  fullHeight: PropTypes.bool
}

export default PhoneNumberInput
